// extracted by mini-css-extract-plugin
module.exports = {"bordered":"FpSelect_bordered__3FYCO","select_label":"FpSelect_select_label__sf5SY","country_select":"FpSelect_country_select__1MKLd"};